import React from 'react';
import { Box, Typography } from '@mui/material';
import { DATE_FORMAT_SLASH } from '../../../../../utils/formatTime';
import DateRangePicker from '../../../../reusable-components/date-range-picker/DateRangePicker';
import './filterField.scss';

interface EventDateFilterFieldProps {
  value: { startDate: Date | null; endDate: Date | null };
  onChange: (startDate: Date | null, endDate: Date | null) => void;
}

const EventDateFilterField: React.FC<EventDateFilterFieldProps> = ({ value, onChange }) => {
  return (
    <Box className="filterField">
      <Typography className="filterFieldLabel">Event date</Typography>
      <Box className="filterFieldInput">
        <DateRangePicker
          value={value}
          onChange={onChange}
          placeholder="Start date - End date"
          label="Event Date Range"
          format={DATE_FORMAT_SLASH}
        />
      </Box>
    </Box>
  );
};

export default EventDateFilterField;
